module.exports = __webpack_public_path__ + "static/screen-esami-6b9a7584336a22e0dfc6f8f10cf9408c.png";